import { change } from 'redux-form';

import { loading, handleErrorException, success, reset } from 'State/actions';
import { getLanguagesAction } from 'Pages/importstudents/state/actions';
import { VENDORLINK_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { getGradesAction } from 'State/grades/actions';
import { getSitesAction } from 'State/sites/actions';

import * as types from './types';

export const getData = () => {
  return async dispatch => {
    try {
      dispatch(loading(types.VENDORLINK_GETDATA_LOADING, true));

      await Promise.all([
        dispatch(getGradesAction()),
        dispatch(getSitesAction()),
        dispatch(getLanguagesAction()),
      ]);
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_GETDATA_ERROR, {
          title: 'Error',
          Message: 'Unable to get lookup information.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_GETDATA_LOADING, false));
    }
  };
};

// Configuration Actions
export const getConfiguration = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_GETCONFIGURATION_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `sisintegration/vendorlink/configuration`
      );

      dispatch(
        success(types.VENDORLINK_GETCONFIGURATION_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_GETCONFIGURATION_ERROR, {
          Title: 'Error',
          Message: 'Unable to get VendorLink integration configuration.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_GETCONFIGURATION_LOADING, false));
    }
  };
};

export const postGetLeaInfoRefIds = values => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_POSTGETLEAINFOREFIDS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/GetLeaInfoRefIds`,
        values
      );

      dispatch(
        success(
          types.VENDORLINK_POSTGETLEAINFOREFIDS_SUCCESS,
          response.data.Data
        )
      );
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.VENDORLINK_POSTGETLEAINFOREFIDS_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to get LEA info ref IDs.',
          }
        )
      );
    } finally {
      dispatch(loading(types.VENDORLINK_POSTGETLEAINFOREFIDS_LOADING, false));
    }
  };
};

export const clearPostGetLeaInfoRefIdsResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDORLINK_POSTGETLEAINFOREFIDS_SUCCESS, null));
    dispatch(reset(types.VENDORLINK_POSTGETLEAINFOREFIDS_ERROR, null));
  };
};

export const postTestConnection = values => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_POSTTESTCONNECTION_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/TestConnection`,
        values
      );

      dispatch(
        success(types.VENDORLINK_POSTTESTCONNECTION_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_POSTTESTCONNECTION_ERROR, {
          Title: 'Error',
          Message: 'Unable to test VendorLink configuration.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_POSTTESTCONNECTION_LOADING, false));
    }
  };
};

export const clearPostTestConnectionResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDORLINK_POSTTESTCONNECTION_SUCCESS, null));
    dispatch(reset(types.VENDORLINK_POSTTESTCONNECTION_ERROR, null));
  };
};

export const setConfiguration = values => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_SETCONFIGURATION_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/configuration`,
        values
      );

      await dispatch(getConfiguration());

      dispatch(
        success(types.VENDORLINK_SETCONFIGURATION_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_SETCONFIGURATION_ERROR, {
          Title: 'Error',
          Message: 'Unable to set VendorLink integration configuration.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_SETCONFIGURATION_LOADING, false));
    }
  };
};

export const clearSetConfigurationResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDORLINK_SETCONFIGURATION_SUCCESS, null));
    dispatch(reset(types.VENDORLINK_SETCONFIGURATION_ERROR, null));
  };
};

// Mapping Actions
export const getMappings = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_GETMAPPINGS_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `sisintegration/vendorlink/mappings`
      );

      dispatch(
        success(types.VENDORLINK_GETMAPPINGS_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_GETMAPPINGS_ERROR, {
          Title: 'Error',
          Message: 'Unable to get VendorLink integration mappings.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_GETMAPPINGS_LOADING, false));
    }
  };
};

export const getSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_GETSITES_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `sisintegration/vendorlink/getschoolinfo`
      );
      dispatch(success(types.VENDORLINK_GETSITES_SUCCESS, response.data.Data));
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_GETSITES_ERROR, {
          Title: 'Error',
          Message: 'Unable to get VendorLink integration sites.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_GETSITES_LOADING, false));
    }
  };
};

export const getGrades = sites => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      let siteIds = sites.map(x => x.Id);
      dispatch(loading(types.VENDORLINK_GETGRADES_LOADING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Grade/GetGradeListForSiteIds`,
        siteIds
      );
      dispatch(success(types.VENDORLINK_GETGRADES_SUCCESS, response.data.Data));
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.VENDORLINK_GETGRADES_ERROR, {
          Title: 'Error',
          Message: 'Unable to get VendorLink integration grades.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_GETGRADES_LOADING, false));
    }
  };
};

export const setMappings = values => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_SETMAPPINGS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/mappings`,
        values
      );

      await dispatch(getMappings());

      dispatch(
        success(types.VENDORLINK_SETMAPPINGS_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_SETMAPPINGS_ERROR, {
          Title: 'Error',
          Message: 'Unable to set VendorLink integration mappings.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_SETMAPPINGS_LOADING, false));
    }
  };
};

export const clearSetMappingsResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDORLINK_SETMAPPINGS_SUCCESS, null));
    dispatch(reset(types.VENDORLINK_SETMAPPINGS_ERROR, null));
  };
};

// Preview Actions
export const getStudentPreview = studentId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_PREVIEW_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/preview`,
        studentId
      );

      dispatch(success(types.VENDORLINK_PREVIEW_SUCCESS, response.data.Data));
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_PREVIEW_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Student Import Preview.',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_PREVIEW_LOADING, false));
    }
  };
};

export const setPreviewStudentId = studentId => {
  return {
    type: types.VENDORLINK_PREVIEW_SET_ID,
    payload: studentId,
  };
};

export const clearPreviewData = () => {
  return {
    type: types.VENDORLINK_PREVIEW_CLEAR_DATA,
  };
};

export const clearPreviewErrors = () => {
  return {
    type: types.VENDORLINK_PREVIEW_CLEAR_ERRORS,
  };
};

export const clearPreviewSuccess = () => {
  return {
    type: types.VENDORLINK_PREVIEW_CLEAR_SUCCESS,
  };
};

export const updatePreviewHasBeenRun = value => {
  return {
    type: types.VENDORLINK_PREVIEW_RAN,
    payload: value,
  };
};

export const updatePreviewSuccess = value => {
  return {
    type: types.VENDORLINK_PREVIEW_UPDATE_SUCCESS,
    payload: value,
  };
};

export const clearStudentId = () => {
  return change(VENDORLINK_PREVIEW_FORM_NAME, 'StudentId', null);
};

// Single Student Import Actions
export const importStudent = studentId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_IMPORT_STUDENT_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/vendorlink/importstudent`,
        studentId
      );

      dispatch(
        success(types.VENDORLINK_IMPORT_STUDENT_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_IMPORT_STUDENT_ERROR, {
          Title: 'Error',
          Message: 'Unable to Import Student',
        })
      );
    } finally {
      dispatch(loading(types.VENDORLINK_IMPORT_STUDENT_LOADING, false));
    }
  };
};

export const clearStudentImportErrors = () => {
  return {
    type: types.VENDORLINK_IMPORT_STUDENT_CLEAR_ERROR,
  };
};

export const setSingleStudentImportSuccess = value => {
  return {
    type: types.VENDORLINK_IMPORT_STUDENT_SET_SUCCESS,
    payload: value,
  };
};

// Bulk Import Actions
export const bulkImport = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDORLINK_BULK_IMPORT_LOADING, true));
      dispatch(success(types.VENDORLINK_BULK_IMPORT_COMPLETE, false));

      await MPWWebApi.getGeneric(`sisintegration/vendorlink/import`);
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDORLINK_BULK_IMPORT_ERRORS, {
          Title: 'Error',
          Message: 'Unable to Import Students',
        })
      );
    }
  };
};

export const updateIsBulkImportComplete = value => {
  return {
    type: types.VENDORLINK_BULK_IMPORT_COMPLETE,
    payload: value,
  };
};

export const updateIsBulkImportLoading = value => {
  return {
    type: types.VENDORLINK_BULK_IMPORT_LOADING,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/state/actions.js